import NavigationHeader from 'components/molecules/navigation-header';
import SearchPatientsByType from 'components/organisms/search-patients-by-type';
import { isValidGuid } from 'infrastructure/functions';
import {
  useFollowUpTableDataQueryFilter,
  useNewlyTableDataQueryFilter,
  usePartialsTableDataQueryFilter,
} from 'infrastructure/hooks/ccm/console';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import { useSearch } from './use-search';

import type { FC } from 'react';
import type { INavigationHeaderProps } from 'components/molecules/navigation-header';

interface IProps extends INavigationHeaderProps {}

const CcmConsoleNavigationHeader: FC<IProps> = ({ title }) => {
  const {
    dataOptions,
    debounceSearch,
    isLoading,
    placeholder,
    options,
    searchKey,
    searchValue,
    DEFAULT_FILTER,
    setSearchValue,
    onSelect,
    onClear,
    onTypeChange,
  } = useSearch();
  const { count: newlyCount, resetFilter: resetNewlyFilter } =
    useNewlyTableDataQueryFilter();
  const { count: partialsCount, resetFilter: resetPartialsFilter } =
    usePartialsTableDataQueryFilter();
  const { count: followUpCount, resetFilter: resetFollowUpFilter } =
    useFollowUpTableDataQueryFilter();
  const { t } = useTranslation();

  const showResetBtn = newlyCount > 0 || partialsCount > 0 || followUpCount > 0;

  const onResetFilters = () => {
    resetFollowUpFilter();
    resetNewlyFilter();
    resetPartialsFilter();
  };

  return (
    <NavigationHeader title={title} className={s.wrapper}>
      <div className={s['actions-wrapper']}>
        {showResetBtn && (
          <BaseButton
            type="secondary"
            onClick={onResetFilters}
            label={t('controls.resetFilters')}
            className={s['reset-btn']}
          />
        )}
        <SearchPatientsByType
          typeOptions={options}
          defaultTypeValue={DEFAULT_FILTER.value}
          dataOptions={dataOptions ?? []}
          typeValue={searchKey}
          searchValue={searchValue}
          isLoading={isLoading}
          placeholder={placeholder}
          onTypeChange={onTypeChange}
          onSelect={onSelect}
          onSearch={(e) => {
            setSearchValue(e.target.value);
            const isGuid = searchKey === 'guid';
            if (isGuid && isValidGuid(e.target.value)) {
              debounceSearch({
                searchKey,
                searchValue: e.target.value,
              });
            } else if (!isGuid) {
              debounceSearch({
                searchKey,
                searchValue: e.target.value,
              });
            }
          }}
          searchWith={350}
          onClear={onClear}
        />
      </div>
    </NavigationHeader>
  );
};

export default CcmConsoleNavigationHeader;
